export default __webpack_public_path__ + "static/media/wB.6a5db4e0.svg";